import type { Palette } from './types';

type StickyProps = { palette: Palette };

export function StickyQuoteButton({ palette }: StickyProps) {
  return (
    <a
      href="#quote"
      className="fixed bottom-4 right-4 z-40 inline-flex items-center justify-center rounded-full px-5 py-3 text-xs font-semibold uppercase tracking-[0.25em] text-white shadow-2xl transition hover:-translate-y-0.5 sm:hidden"
      style={{ backgroundColor: palette.clay }}
    >
      Get Quote
    </a>
  );
}
